import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Level1List } from './Level1List';
import mask from './mask';
export const PcMenu = ({ data }) => {
    const masker = useMemo(() => mask(), []);
    return (_jsx(_Fragment, { children: _jsx(Box, { height: '100%', display: { base: 'none', lg: 'flex' }, alignItems: 'center', onMouseEnter: () => {
                masker.create();
                masker.show();
            }, onMouseLeave: () => {
                masker.hide();
            }, children: data.map((level1, level1Index) => {
                return (_jsx(Level1List, { data: {
                        level1,
                        level1Index,
                    }, alignRight: level1Index >= data.length - 1 }, `${level1.key}-${level1Index}-level1-item`));
            }) }) }));
};
